import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

import BaseLoadingSpinner from '../LoadingSpinnerV1'
import BaseNotification from '../Notification'
import BaseButton from '../ButtonV1'

export const ChangeNotification = styled(BaseNotification)`
  padding-top: 1.25rem;

  ${p => p.format === 'app' && `margin: 0 0 1.25rem 0;`}
  ${p => p.format === 'admin' && `margin: 0 0 1.25rem;`}

  & > div {
    width: 100%;
    font-family: sidecarta-sans;
  }
  ul {
    margin-left: 1.25rem;
    margin-top: 0.125rem;
  }
  li {
    font-size: 1.125rem;
    line-height: 1.5625rem;
  }
`
export const Title = styled.div`
  font-size: 1.5rem;
  font-family: sidecarta-sans-bold;
  display: flex;
`
export const SubTitle = styled.div`
  font-size: 1.125rem;
  font-family: sidecarta-sans-bold;
  margin-top: 0.9375rem
  margin-bottom: 0rem
`
export const SubLine = styled.div`
  font-size: 1.125rem;
  margin-bottom: 0.9375rem;
`
export const SubTitleStep = styled.div`
  font-size: 1.125rem;
  font-family: sidecarta-sans-bold;
  margin-top: 0.125rem;
  margin-bottom: 0rem;
`
export const SubLineStep = styled.div`
  font-size: 1.125rem;
`
export const Acknowledgement = styled.div`
  ${p =>
    p.format === 'admin' &&
    `
    margin-top: 1.875rem;
    font-size: 1.125rem;
    line-height: 1.5625rem;
  `}
  ${p =>
    p.format === 'app' &&
    `
    font-size: 0.875rem;
    line-height: 1.25rem;
  `}
`

export const Text = styled.p`
  display: block;
  font-size: 1.125rem;
  line-height: 1.5625rem;
  white-space: pre;
  color: ${color.WHITE};
  margin-top: 0.75rem;
  margin-bottom: 0.125rem;
  &:not(:last-of-type) {
    margin-right: 0.3125rem;
  }
  ${p => p.error && `color: ${color.WATERMELON}`}
`

export const MisstatementButtons = styled.div`
  display: flex;
  max-width: calc(100% - 1.875rem);
  padding: 1.25rem 0 1.25rem 1.875rem;
`

export const MisstatementButtonContainer = styled.div`
  flex: 1 1 0;
  width: 0;
  max-width: 7.8125rem;
  margin-right: 0.625rem;
  &:last-child {
    margin-right: 0;
  }
`

export const MisstatementActionButton = styled(BaseButton)`
  font-size: 1.0625rem;
  line-height: 1.5625rem;
  border-color: ${color.WHITE};
  color: ${color.WHITE};
  margin-right: 20px;

  max-width: 100%;
  &:last-child {
    margin-right: 0;
  }
  span {
    font-size: 1.5rem;
    left: 1.25rem !important;
  }
`

export const LoadingSpinner = styled(BaseLoadingSpinner)`
  height: 1.5rem;
  width: 1.5rem;
  padding: 0;
  font-size: 1.5rem;
  position: relative;
  z-index: 100;
`
